import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';

const slideIn = keyframes`
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const slideOut = keyframes`
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(-100%);
    opacity: 0;
  }
`;

const ToastContainer = styled.div`
  position: fixed;
  top: var(--space-5);
  right: var(--space-5);
  padding: var(--space-4) var(--space-6);
  border-radius: var(--radius-xl);
  background: linear-gradient(135deg,
    ${props => props.type === 'error' ? 'var(--error-600)' : 'var(--success-600)'} 0%,
    ${props => props.type === 'error' ? 'var(--error-700)' : 'var(--success-700)'} 100%
  );
  color: white;
  box-shadow: var(--shadow-xl);
  z-index: 1000;
  animation: ${props => props.isClosing ? slideOut : slideIn} 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: var(--text-sm);
  font-weight: 500;
  font-family: var(--font-heading-regular);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid ${props => props.type === 'error' ? 'var(--error-400)' : 'var(--success-400)'};
  min-width: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

function Toast({ message, type = 'success', duration = 3000, onClose }) {
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsClosing(true);
      setTimeout(onClose, 300);
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <ToastContainer type={type} isClosing={isClosing}>
      {message}
    </ToastContainer>
  );
}

export default Toast;